import { Icon24BGCFilled, Icon24Info } from '@care/react-embrace-icons';
import { Box, Button, Typography, IconButton } from '@mui/material';
import { useState } from 'react';
import { AmplitudeEvent, trackAmplitudeEvent } from '@/lib/analyticsHelper';
import { SafetyModalWrapper } from '@/components/SafetyModalWrapper';
import { useResponsive } from '@/components/hooks/useResponsive';

export const BackgroundCheckTrustBadge = () => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const { isSmallViewport } = useResponsive();

  const handleLearnMoreClick = () => {
    setOpenModal(true);

    trackAmplitudeEvent(AmplitudeEvent.ctaInteracted, {
      cta_text: 'Learn more',
    });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: { xs: 'center', sm: 'flex-start' },
        overflow: { sm: 'visible' },
      }}>
      <Icon24BGCFilled sx={{ mr: { xs: 1, sm: 0 } }} />
      <Typography variant={isSmallViewport ? 'h5' : 'h4'} whiteSpace={{ sm: 'nowrap' }}>
        All caregivers with this badge are background checked.
      </Typography>
      {!isSmallViewport && (
        <Button
          variant="text"
          component="button"
          onClick={handleLearnMoreClick}
          sx={{
            ml: { sm: 1.5, md: 1 },
            textDecoration: 'underline',
            whiteSpace: 'nowrap',
          }}>
          Learn more
        </Button>
      )}
      {isSmallViewport && (
        <IconButton aria-label="Learn more" onClick={handleLearnMoreClick}>
          <Icon24Info />
        </IconButton>
      )}
      <SafetyModalWrapper openModal={openModal} setOpenModal={setOpenModal} />
    </Box>
  );
};
